<template>
  <div>
    <div class="mb-10px text-right" v-if="formData.workflowTaskId">
      <el-button size="mini" @click="viewProcess(formData)">查看流程</el-button>
    </div>
    <el-form ref="formData" label-width="150px" :model="formData">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
          <el-form-item label="隐患描述" prop="hiddenDangerName">
            <el-input
              v-model="formData.hiddenDangerName"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 6 }"
              clearable
              :disabled="formProps.editType === 'read'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
          <el-form-item label="隐患编码" prop="hiddenDangerCode">
            <el-input
              v-model="formData.hiddenDangerCode"
              clearable
              :disabled="formProps.editType === 'read'"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
          <el-form-item label="隐患类别" :rules="[{ required: true, message: '请选择隐患类别', trigger: 'change' }]"  prop="hiddenDangerCategory">
            <el-select
              v-model="formData.hiddenDangerCategory"
              class="w-full"
              filterable
              clearable
              :disabled="formProps.editType === 'read'"
            >
              <el-option
                v-for="item in hiddenCategoryList"
                :key="item.code"
                :label="item.displayName"
                :value="Number(item.code)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
          <el-form-item label="所属风险区域" prop="areaId">
            <el-select
              v-model="formData.areaId"
              class="w-full"
              clearable
              filterable
              :disabled="formProps.editType === 'read'"
            >
              <el-option
                v-for="item in areaList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
          <el-form-item label="隐患来源" prop="hiddenDangerSource">
            <el-select
              v-model="formData.hiddenDangerSource"
              class="w-full"
              clearable
              filterable
              :disabled="formProps.editType === 'read'"
            >
              <el-option
                v-for="item in hiddenSourceList"
                :key="item.code"
                :label="item.displayName"
                :value="Number(item.code)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
          <el-form-item label="隐患等级" prop="hiddenDangerlevel">
            <el-select
              v-model="formData.hiddenDangerlevel"
              class="w-full"
              clearable
              filterable
              :disabled="formProps.editType === 'read' && !isEditLevel"
            >
              <el-option
                v-for="item in hiddenLevelList"
                :key="item.code"
                :label="item.displayName"
                :value="Number(item.code)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!-- <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
          <el-form-item label="隐患类型" prop="hiddenDangerType">
            <el-select
              v-model="formData.hiddenDangerType"
              class="w-full"
              filterable
              clearable
              :disabled="formProps.editType === 'read'"
            >
              <el-option
                v-for="item in hiddenTypeList"
                :key="item.code"
                :label="item.displayName"
                :value="Number(item.code)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
      </el-row>
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
          <el-form-item label="所属系统/机组" prop="ownedSystemOrUnit">
            <el-select
              multiple
              :value="formData.ownedSystemOrUnit ? formData.ownedSystemOrUnit.split(',') : []"
              class="w-full"
              filterable
              clearable
              :disabled="formProps.editType === 'read'"
            >
              <el-option
                v-for="item in ownedSystemOrUnitList"
                :key="item.id"
                :label="item.displayName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
          <el-form-item label="隐患可能危害" prop="hiddenDangerHarm">
            <el-input
              v-model="formData.hiddenDangerHarm"
              placeholder="请输入隐患可能危害"
              clearable
              :disabled="formProps.editType === 'read'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
          <el-form-item label="上报人" prop="reporterName">
            <el-input
              v-model="formData.reporterName"
              clearable
              :disabled="formProps.editType === 'read'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
          <el-form-item label="上报时间" prop="reportTime">
            <el-date-picker
              size="small"
              v-model="formData.reportTime"
              :disabled="formProps.editType === 'read'"
              type="datetime"
              class="!w-full"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
          <el-form-item label="安全检查标题">
            <el-input
              v-model="formData.safetyInspectionTitle"
              class="w-full"
              :disabled="formProps.editType === 'read'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
          <el-form-item label="安全检查期数">
            <el-input
              v-model="formData.safetyInspectionPeriods"
              class="w-full"
              :disabled="formProps.editType === 'read'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
          <el-form-item label="建议整改措施">
            <el-input
              v-model="formData.suggestedRectificationMeasures"
              class="w-full"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 6 }"
              :disabled="formProps.editType === 'read'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            label="整改前图片"
            prop="photosBeforeRectification"
            ref="photosBeforeRectification"
          >
            <img-upload
              v-model="formData.photosBeforeRectification"
              :upload-width="120"
              :upload-height="120"
              :maxSize="20"
              :limit="99"
              :isDisabledUploadComponent="formProps.editType === 'read'"
              :isShowDeleteButton="formProps.editType !== 'read'"
            ></img-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 查看流程start -->
    <ApprovalFlowDialog
      :visible.sync="showFlowDialog"
      v-if="showFlowDialog"
      :id="formData.workflowTaskId"
    ></ApprovalFlowDialog>
    <!-- 查看流程end -->
  </div>
</template>

<script>
import uuid from 'uuid'
import dayjs from 'dayjs'
import { AreaApi } from '@wiz-api/area-management'
import utils from '@/components/safety/enumField/utils'

// import PersonSelect from '@/components/safety/FormSelect/PersonSelect'
import ImgUpload from '@/components/safety/ImgUpload/ImgUpload'
import ApprovalFlowDialog from '@/components/safety/ApprovalFlow/ApprovalFlowDialog'
import PointSelect from '../PointSelect/PointSelect'

const areaApi = new AreaApi()

export default {
  name: 'hidden-list-detail',
  components: {
    // PersonSelect,
    ImgUpload,
    PointSelect,
    ApprovalFlowDialog,
  },
  props: {
    FormData: {
      type: Object,
      default: () => {},
    },
    formProps: {
      default: () => {
        return {
          title: '',
          editType: 'read',
          visible: true,
        }
      },
    },
    isEditLevel: {
      default: false,
    },
  },
  data() {
    return {
      areaList: [],
      hiddenCategoryList: [],
      hiddenTypeList: [],
      hiddenLevelList: [],
      ownedSystemOrUnitList: [],
      hiddenSourceList: [],
      formData: {},
      rules: {},
      collapseActiveName: ['baseInfo'],
      showFlowDialog: false, // 是否显示审批流程页面
      flowid: '', // 查看流程项流程id
      groupid: '',
    }
  },
  watch: {
    FormData: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData = JSON.parse(JSON.stringify(newVal))
        } else {
          this.formData = {}
        }
      },
      immediate: true,
    },
  },
  computed: {},
  created() {
    this.getAreaList()
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.HiddenSource',
        'DoublePreventionManagement.DataCategory.HiddenLevel',
        'DoublePreventionManagement.DataCategory.HiddenType',
        'DoublePreventionManagement.DataCategory.HiddenCategory',
        'DoublePreventionManagement.DataCategory.OwnedSystemOrUnit',
      ],
      [
        'hiddenSourceList',
        'hiddenLevelList',
        'hiddenTypeList',
        'hiddenCategoryList',
        'ownedSystemOrUnitList',
      ],
      this
    )
  },
  mounted() {},

  methods: {
    viewProcess() {
      if (
        typeof this.formData.workflowTaskId === 'string' &&
        _.includes(this.formData.workflowTaskId, '-')
      ) {
        window.wiz.OpenWorkFlowDesignByFlowId(this.formData.workflowTaskId)
        return
      }
      this.showFlowDialog = true
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-icon-arrow-right {
  display: none;
}
::v-deep .el-badge__content {
  top: 10px;
}
</style>
